export enum Action {
  DELETE = 'DELETE',
  ROLLBACK = 'ROLLBACK',
}

export const DELETE = 'DELETE';
